import React from 'react';
import { CtaButton } from './ui/CtaButton';
import { SectionHeading } from './ui/SectionHeading';
import { gallery } from '../data/gallery';
import { WHATSAPP_ORDER_LINK } from '../utils/whatsapp';
export function ProofGallery() {
  return <section className="w-full bg-cream px-4 py-16 sm:px-6 sm:py-20" data-id="element-114" data-mp="2r91gwf5gxoy2">
      <div className="mx-auto w-full max-w-6xl" data-id="element-115" data-mp="2mahr23nr7t0f">
        <SectionHeading title="Pedidos reales, comida real" subtitle="Empanadas argentinas preparadas por Blue & White en Costa Rica, listas para disfrutar y compartir." data-id="element-116" data-mp="2m7lrkaw9cw9v" />

        <ul className="mt-10 grid grid-cols-2 gap-3 sm:grid-cols-3" data-id="element-117" data-mp="3ew9kmsn90pxz">
          {gallery.map(item => <li key={item.id} className="overflow-hidden rounded-2xl border border-aqua-200 bg-white" data-id="element-118" data-mp="34zy5luw9xlzu">
              <img src={item.image} alt={item.alt} className="aspect-square w-full object-cover" loading="lazy" data-id="element-119" data-mp="1ykx9np7913t9" />
            </li>)}
        </ul>

        <p className="mt-4 text-center text-[12.5px] text-muted" data-id="element-120" data-mp="3jaws3xauoxzw">
          Agregá aquí fotos reales de pedidos y reseñas autorizadas cuando estén
          disponibles.
        </p>

        <div className="mt-8 flex justify-center" data-id="element-121" data-mp="39ea6v7em44xc">
          <CtaButton href={WHATSAPP_ORDER_LINK} track="whatsapp-proof-click" data-id="element-122" data-mp="3edmye5gfi069">
            Pedir por WhatsApp
          </CtaButton>
        </div>
      </div>
    </section>;
}